  (function () {
    var SPACING = 30;
    

    function getExtraTopOffset() {
      var mainContent = document.getElementById('MainContent');
      return mainContent ? mainContent.getBoundingClientRect().top + window.scrollY : 100;
    }

    function getHeaderHeight(el) {
      var sel = el.getAttribute('data-sticky-header');
      if (!sel) return SPACING;
      var header = document.querySelector(sel);
      return header ? header.offsetHeight : SPACING;
    }

    function StickySidebar(el) {
      this.el = el;
      this.lastY = window.scrollY;
      this.stickyTop = 0;
      this.enabled = false;
      this._resizeTimer = null;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onElementResize = this.onElementResize.bind(this);

      this.calculate();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      // Obserwuj zmiany wysokości samego elementu is-sticky (dynamiczne treści, akordeon)
      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver(this.onElementResize);
        this._resizeObserver.observe(this.el);
      }
    }

    StickySidebar.prototype.calculate = function () {
      this.lastY = window.scrollY;
      this.headerH = getHeaderHeight(this.el);
      this.elHeight = this.el.offsetHeight;
      this.viewportHeight = window.innerHeight;

      // Jeśli element mieści się w viewport - proste sticky
      if (this.elHeight + this.headerH + SPACING <= this.viewportHeight) {
        this.enabled = false;
        this.el.style.position = 'sticky';
        this.el.style.top = this.headerH + 'px';        
        return;
      }

      var wasEnabled = this.enabled;
      this.enabled = true;
      this.el.style.position = 'sticky';
      
      // Górna granica bazowa: element przyklejony u góry (pod headerem)
      this.topLimitBase = this.headerH;
      // Dolna granica: element przyklejony u dołu
      this.bottomLimit = this.viewportHeight - this.elHeight - SPACING;

      if (!wasEnabled) {
        // Pierwsze uruchomienie - zacznij przyklejony do góry
        this.stickyTop = this.topLimitBase;
      } else {
        // Po zmianie wysokości - przytnij bieżącą pozycję do nowych granic
        var extraTopOffset = getExtraTopOffset();
        var extraOffset = Math.min(extraTopOffset, window.scrollY);
        var topLimit = this.topLimitBase + extraOffset;
        if (this.stickyTop > topLimit) this.stickyTop = topLimit;
        if (this.stickyTop < this.bottomLimit) this.stickyTop = this.bottomLimit;
      }

      this.el.style.top = this.stickyTop + 'px';      
    };

    StickySidebar.prototype.onElementResize = function () {
      // Debounce - odczekaj aż animacja CSS akordeonu się zakończy
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.calculate(), 50);
    };

    StickySidebar.prototype.onResize = function () {
      this.calculate();
    };

    StickySidebar.prototype.onScroll = function () {
      if (!this.enabled) return;

      var y = window.scrollY;
      var delta = y - this.lastY;
      
      // Oblicz dynamiczny topLimit z dodatkowym offsetem
      // Offset zmniejsza się płynnie gdy zbliżamy się do góry strony
      var extraTopOffset = getExtraTopOffset();
      var extraOffset = Math.min(extraTopOffset, y);
      var topLimit = this.topLimitBase + extraOffset;
      
      // Nowa wartość top: przesuwamy w przeciwnym kierunku do scrollu
      var newTop = this.stickyTop - delta;
      
      // Ogranicz do granic
      if (newTop > topLimit) {
        newTop = topLimit;
      } else if (newTop < this.bottomLimit) {
        newTop = this.bottomLimit;
      }
      
      this.stickyTop = newTop;
      this.el.style.top = newTop + 'px';
      this.lastY = y;
    };

    StickySidebar.prototype.destroy = function () {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this._resizeTimer);

      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }

      this.el.style.removeProperty('position');
      this.el.style.removeProperty('top');
    };

    var instances = [];

    function initAll() {
      instances.forEach(function (i) { i.destroy(); });
      instances = [];
      document.querySelectorAll('.is-sticky').forEach(function (el) {
        instances.push(new StickySidebar(el));
      });
    }

    document.addEventListener('DOMContentLoaded', initAll);
    window.__refreshStickyTop = initAll;
  })();